module.exports = __webpack_public_path__ + "9502368d3bbfa00f7bf67b18419715af.svg";